import { Avatar, Button, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { colors } from "../../styles";
import { IUserType } from "../../types";
import { typeToKor } from "../../utils";

interface ProfileListItemProps {
    avatar?: string;
    nickname: string;
    userType: IUserType;
    onUnblock: () => void;
    isUnblocking?: boolean;
}

export default function ProfileListItem({
    avatar,
    nickname,
    userType,
    onUnblock,
    isUnblocking,
}: ProfileListItemProps) {
    return (
        <HStack
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            paddingY={2}
        >
            <HStack gap={2} alignItems="center" flex={1} minWidth={0}>
                {avatar ? (
                    <Image
                        src={avatar}
                        alt={`${nickname} 프로필 이미지`}
                        width={8}
                        height={8}
                        borderRadius="full"
                        objectFit="cover"
                        flexShrink={0}
                    />
                ) : (
                    <Image 
                        src={"/png/profile.png"}
                        alt="프로필 이미지"
                        width={8}
                        height={8}
                        borderRadius="full"
                        objectFit="cover"
                        flexShrink={0}
                    />
                )}
                <VStack
                    justifyContent={"center"}
                    alignItems={"flex-start"}
                    spacing={0}
                >
                    <Text fontSize={14} fontWeight={600} color={colors.g1} noOfLines={1}>
                        {nickname}
                    </Text>
                    <Text fontSize={12} fontWeight={500} color={colors.g3}>
                        {typeToKor(userType)}
                    </Text>
                </VStack>
            </HStack>

            <Button
                variant="ghost"
                size="sm"
                color={colors.blue}
                fontSize={14}
                fontWeight={500}
                flexShrink={0}
                onClick={onUnblock}
                isLoading={isUnblocking}
            >
                해제
            </Button>
        </HStack>
    );
}
